/* KANON `Programy v2 - D3 (0.8)` — what a CLIENT'S PLAN row adds to the shared anatomy.
 *
 * Everything it has in common with a template row is in `listRow.module.css`. What is here is the
 * leading avatar column, the extra 11px of height it buys, the progress bar under the sub-line and
 * the percent in the last track.
 *
 * Read off the rendered specimen at 1512×1000, then re-cut a fifth taller by owner decision D28 of
 * 4 September 2026:
 *   row      grid `42px 61px minmax(0,1fr) 108px 48px`, height 86
 *            (canon: `35px 51px minmax(0,1fr) 86.5px 83px`, height 72 — `ROW_D + 11`)
 *   avatar   38 inside a 42px track, centred — the canon's 32-in-35 on the same fifth
 *   bar      2.5 tall, 4 under the sub-line, max 136 wide, --bg-sunken with a --cat-ink fill
 *   percent  --fs-pl-row / 700 / --text-2, tabular, flush right
 *
 * The two fixed tracks are `TemplateRow.module.css`'s reasoning, and both bind harder here:
 * `12 / 30 treningów` is a longer run than a template row carries, and this row's name column is
 * the one that was measured eliding a `Anna Kowalska` before the last track gave its slack up.
 *
 * Heights and widths are layout rather than design tokens (see stylelint.config.js); every colour,
 * space, radius and type value below is a token. */

.row {
  grid-template-columns: 42px var(--w-pl-cover) minmax(0, 1fr) 108px 48px;
  height: var(--h-pl-row-client);
}

/* A 42px track holding a 38px disc: the canon's 35-and-32 pair on D28's fifth, and the disc is
 * centred in it rather than flush, so the covers beside it keep one left edge across both scopes.
 *
 * `--sz-avatar` is `shared/ui/AvatarChip`'s own seam — the diameter, and nothing else about the
 * disc, is what a surface may state. See that module's header. */
.avatarCell {
  --sz-avatar: var(--sz-pl-row-avatar);

  display: flex;
  align-items: center;
  justify-content: center;
}

/* The bar is the LAST child of the shared `.identity` column, which sets the 3px gap between the
 * name and the sub-line; the extra 4px here is the specimen's own `marginTop` and is what separates
 * a measurement from a line of text. */
.bar {
  width: 100%;
  max-width: 136px;
  height: 2.5px;
  margin-top: var(--space-1);
  overflow: hidden;
  background: var(--bg-sunken);
  border-radius: var(--radius-hair);
}

/* The width is the percent and the colour is the CATEGORY — never the progress. A bar that turned
 * with the figure would be a judgement on the client, and this screen does not make one. */
.barFill {
  display: block;
  width: var(--pl-progress);
  height: 100%;
  background: var(--cat-ink);
  border-radius: var(--radius-hair);
}

.progress {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.percent {
  flex: none;
  font-size: var(--fs-pl-row);
  font-weight: var(--fw-bold);
  line-height: var(--lh-auto);
  color: var(--text-2);
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
